import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared/shared.module';

import { MacroGroupRoutingModule } from './macro-groups-routing.module';
import { CreateMacroGroupsFormComponent } from './create-macro-groups-form/create-macro-groups-form.component';
import { AdminGuard } from '@app/core/guards/admin.guard';

@NgModule({
  imports: [
    MacroGroupRoutingModule,
    SharedModule
  ],
  declarations: [
    CreateMacroGroupsFormComponent
  ],
  providers: [ AdminGuard ]
})
export class MacroGroupsModule { }
